import React from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';

import { Card } from '@mui/material';

import Logo from './Logo';
import ControlMesage from '../Control/ControlMessage';
import './shared.css';

export const PageNotFound = () => {
  const history = useNavigate();

  const message = 'This page was not found';

  return (
    <Card sx={{ boxShadow: 'none', border: 'none' }} className='center'>
      <Logo />
      <ControlMesage controlMessage={message} />

      <Button
        className='center'
        variant='contained'
        size='small'
        onClick={() => {
          history('/');
        }}
      >
        Take Me Back
      </Button>
    </Card>
  );
};
